import { ItemLabelPrintData } from "src/apis/itemLabelApi";
import { formatDate } from "src/utils/string/stringUtil";

export interface WMS2091_R01StoreData {
	WMS2091_R01DetailList: any[];
	editWMS2091_R01: any;
}

const formatQty = (qty: number | undefined, unit: string): string => {
	if (!qty && qty !== 0) return "";
	return `${qty.toLocaleString()}${unit || "EA"}`;
};

const WMS2091_R01_buildItemLabelDataFromDetail = (
	detail: any,
	header: any
): ItemLabelPrintData => {
	if (!detail) throw new Error("상세 데이터가 없어 라벨을 생성할 수 없습니다.");
	if (!header) throw new Error("헤더 정보가 없어 라벨을 생성할 수 없습니다.");

	const transportDate = header.transportDt
		? formatDate(new Date(header.transportDt))
		: formatDate(new Date());

	const qty = detail.qty ?? 0;

	return {
		itemCd: detail.itemCd || "",
		itemNm: detail.itemNm || "",
		itemSpec: detail.itemSpec || "",
		transportDate,
		storageLocation: detail.locationNm || detail.locationCd || "-",
		qty: formatQty(qty, detail.unit || "EA"),
		customer: header.customNm || "",
		customerItemCd: detail.customerItemCd || detail.itemCd || "",
		labelType: "[INITIAL-STOCK]",
	};
};

export const WMS2091_R01_extractUnprintedItemLabelData = (
	store: WMS2091_R01StoreData,
	deletedDetailList: string[] = []
): ItemLabelPrintData[] => {
	const { WMS2091_R01DetailList } = store;
	const unprintedLabelData: ItemLabelPrintData[] = [];
	const deletedSet = new Set(deletedDetailList);

	WMS2091_R01DetailList.forEach((detail: any) => {
		const valueIndex = detail.valueIndex?.toString() ?? "";
		const qty = detail.qty ?? 0;
		if (
			!deletedSet.has(valueIndex) &&
			!detail.printed &&
			qty > 0
		) {
			try {
				unprintedLabelData.push(
					WMS2091_R01_buildItemLabelDataFromDetail(detail, store.editWMS2091_R01)
				);
			} catch (error) {
				console.error(`라벨 데이터 생성 중 오류: ${detail.itemCd}`, error);
			}
		}
	});

	return unprintedLabelData;
};
